export default "__VITE_ASSET__BpXXVyqb__"